export const googleMapKey = "AIzaSyDAx2xJ9TEpGOR0MwOpNeZ3CpnLJPYAHyU";
